import React, { useState, useEffect } from "react"

import Typography from "@material-ui/core/Typography"
import Container from "@material-ui/core/Container"
import TextField from "@material-ui/core/TextField"
import Divider from "@material-ui/core/Divider"
import Button from "@material-ui/core/Button"
import Link from "@material-ui/core/Link"
import CircularProgress from "@material-ui/core/CircularProgress"
import SnackbarContent from "@material-ui/core/SnackbarContent"

import useDefaultStyles from "../../../styles/default"

import api from "../../../services/api"
import { useValidation } from "../../../services/validation"
import { useNavigation } from "../../../services/navigation"
import log from "../../../services/log"

import { forceLowerCase } from "../../../utils/sanitization"
import { submitOnPressEnter } from "../../../utils/submit"

const Login = () => {
	const { navigate, getRouteParams } = useNavigation()

	const { hash } = getRouteParams()

	const inputs = [
		"email",
		"password"
	]
	const [validation, clearValidation, triggerValidation] = useValidation(inputs)

	const defaultClasses = useDefaultStyles()

	const [loginData, setLoginData] = useState({ email: "", password: "" })
	const [loadingLogin, setLoadingLogin] = useState(false)
	const [isPasswordIncorrect, setIsPasswordIncorrect] = useState(false)
	const [isEmailIncorrect, setIsEmailIncorrect] = useState(false)

	const handleLogin = async () => {
		setLoadingLogin(true)

		try {
			await api.post(`/home/hash/${hash}/login`, { ...loginData })

			log.scheduleLoginBlockNotification()

			navigate(`/${hash}`, { keepQueryParams: true, refreshPage: true })
		} catch (error) {
			triggerValidation(error)

			const messages = (error.response && error.response.data && error.response.data.messages) || []

			const getMessage = (id) => messages.find(message => message.id === id)

			const passwordMessage = getMessage("password")
			const emailMessage = getMessage("email")

			if (passwordMessage) {
				setIsPasswordIncorrect(true)
			} else if (emailMessage && emailMessage.help && emailMessage.help.includes("cadastrado")) {
				setIsEmailIncorrect(true)
			}
		}

		setLoadingLogin(false)
	}

	const handleChangeLoginData = (key, value) => {
		setLoginData({
			...loginData,
			[key]: value
		})

		clearValidation(key)

		if (key === "password") {
			setIsPasswordIncorrect(false)
		}

		if (key === "email") {
			setIsEmailIncorrect(false)
		}
	}

	useEffect(() => {
		submitOnPressEnter()
	}, [])

	return (
		<Container className={defaultClasses.container}>
			<Typography variant="h6">
				Entrar
			</Typography>

			<Typography variant="subtitle1">
				Para iniciar a sua escolha de fotos é necessário que faça o login ou se
				cadastre
			</Typography>

			<Divider className={defaultClasses.invisibleDividerMedium} />

			<TextField
				required
				label="Email"
				variant="standard"
				color="secondary"
				size="small"
				value={forceLowerCase(loginData.email)}
				error={!!validation.email.validateStatus}
				helperText={validation.email.help}
				onChange={({ target }) => handleChangeLoginData("email", target.value)}
			/>

			<Divider className={defaultClasses.invisibleDividerSmall} />

			{isEmailIncorrect && (
				<SnackbarContent
					elevation={0}
					className={defaultClasses.infoSnackbar}
					message={(
						<>
							Caso esse email não estiver cadastrado nessa galeria, basta{" "}
							<Link onClick={() => navigate(`/${hash}/signup`)}>cadastrá-lo</Link> agora mesmo.
						</>
					)}
				/>
			)}

			<Divider className={defaultClasses.invisibleDividerMedium} />

			<TextField
				required
				label="Senha"
				type="password"
				autoComplete="current-password"
				variant="standard"
				color="secondary"
				size="small"
				value={loginData.password}
				error={!!validation.password.validateStatus}
				helperText={validation.password.help}
				onChange={({ target }) =>
					handleChangeLoginData("password", target.value.trim())
				}
			/>

			<Divider className={defaultClasses.invisibleDividerSmall} />

			{isPasswordIncorrect ? (
				<SnackbarContent
					elevation={0}
					className={defaultClasses.infoSnackbar}
					message={(
						<>
							Caso tenha esquecido sua senha, utilize nosso recurso de{" "}
							<Link onClick={() => navigate(`/${hash}/request-recovery`)}>recuperar senha</Link>.
						</>
					)}
				/>
			) : (
				<Typography
					variant="caption"
					className={defaultClasses.rightedTypography}
				>
					<Link onClick={() => navigate(`/${hash}/request-recovery`)}>Esqueceu a senha?</Link>
				</Typography>
			)}

			<Divider className={defaultClasses.invisibleDividerMedium} />

			<Button
				variant="contained"
				color="secondary"
				className={defaultClasses.buttonBlock}
				onClick={() => handleLogin()}
				disabled={loadingLogin}
				endIcon={loadingLogin && <CircularProgress size={20} />}
				id="submit"
			>
				Entrar
			</Button>

			<Divider className={defaultClasses.invisibleDividerMedium} />

			<Typography
				variant="subtitle2"
				className={defaultClasses.centeredTypography}
			>
				* Se você não possui a senha para acessar,
				<br />
				basta <Link onClick={() => navigate(`/${hash}/signup`, { keepQueryParams: true })}>
					criar a sua senha
				</Link>{" "}
				agora mesmo.
			</Typography>
		</Container>
	)
}

Login.propTypes = {
}

export default Login
